import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import default_image_url from '../../redux/api/API';
import MainLoading from '../../utils/MainLoading';

const ProductsModal = (props) => {
    const [loading, setLoading] = useState(false)
    const [cmpData, setCmpData] = useState([])
    const dispatch = useDispatch()
    const data = useSelector(state => state.saloon_detail)

    useEffect(() => {
        setLoading(true)
    }, [props.id])

    useEffect(() => {
        setLoading(false)
        setCmpData(data.saloon_detail.users.filter(item => item.id === props.id)[0].products)
    }, [data.saloon_detail])

  return (
        <>
            {props.show && (
                <Modal show={props.show} size='lg' className='expo_products_modal' >
                    {loading ?
                        <MainLoading />
                    :
                    <>
                        <Modal.Header>
                            <Modal.Title> محصولات غرفه </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {cmpData && cmpData.length ? 
                                <div className='modal_product_container'>
                                    {cmpData.map(pr => (
                                        <Link target="_blank" to={`/product/${pr.id}`} className='col-lg-4 col-12 modal_product' key={pr.id}>
                                            <div>
                                                <div className='d-flex justify-content-center'>
                                                {pr.photos.filter(photo => photo.type === "main").length ?
                                                    <img src={default_image_url+pr.photos.filter(photo => photo.type === "main").map(item => item.small_path)} key={pr.id} />
                                                :
                                                    <img src='/assets/img/product_icon.png' key={pr.id} />
                                                }
                                                </div>
                                                <h1>{pr.name}</h1>
                                                <span>برند: {pr.brand}</span>
                                                <div>قیمت: 
                                                    <span className='line_through'> {pr.sell_price === pr.price ? '' : pr.sell_price}</span>
                                                    <span>{pr.price} ریال</span>
                                                </div>
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                            :
                               <h6 className='text-center py-4'>محصولی ایجاد نشده است</h6>
                            }
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={props.close} className='px-3 btn-sm'>
                                بستن
                            </Button>
                        </Modal.Footer>
                    </>
                }
                </Modal>
            )}
        </>
    )
};

export default ProductsModal;
